import React from 'react';
import { Box, Dialog, IconButton, Typography } from '@mui/material';
import { modalHeaderStyle, modalTitleStyle } from 'ui/modals/modalGlobal';
import { dialogStyleAddModal } from 'ui/modals/modalAdd/modalAdd';
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';
import { Button as SpectrumButton } from '@bestdoctor/spectrum-uikit/Button';
import { AddPatientDialog } from 'interfaces/shared/modals/modalsInterfaces';

export const CrossingByCompany: React.FC<AddPatientDialog> = ({ open, handleClose, handleCancel, handleSubmit }) => (
  <Dialog open={open} onClose={handleClose} sx={{ ...dialogStyleAddModal, fullWidth: 'true' }}>
    <Box sx={modalHeaderStyle}>
      <Box sx={{ width: '100%' }}>
        <Typography variant="h3" sx={{ ...modalTitleStyle, marginBottom: '52px' }}>
          Подтверждение подкрепления
        </Typography>
      </Box>
      <IconButton aria-label="close modal" sx={{ width: '40px', height: '40px' }} onClick={handleClose}>
        <CloseOutlinedIcon fontSize="small" />
      </IconButton>
    </Box>
    <Box
      component="p"
      sx={{
        margin: '-24px 0 0 24px',
        fontStyle: 'normal',
        fontWeight: '400',
        fontSize: '14px',
        lineHeight: '18px',
        letterSpacing: '0.02em',
        color: 'rgba(62, 65, 77, 0.6)',
      }}
    >
      Пациент уже прикреплен в выбранной компании по программе Наименование программы на срок с Дата начала действия
      слота по Дата окончания действия слота. Вы уверены, что хотите создать для данного пациента дополнительный полис
      по программе Наименование новой программы
    </Box>
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'end',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          marginRight: '24px',
          marginTop: '20px',
          marginBottom: '20px',
        }}
      >
        <SpectrumButton variant="pseudo" onClick={handleCancel}>
          Нет
        </SpectrumButton>
        <SpectrumButton variant="promo" onClick={handleSubmit}>
          Да
        </SpectrumButton>
      </Box>
    </Box>
  </Dialog>
);
